import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-default-export */
import { Routing } from '@/pages';
import { withProviders } from './providers';
import './styles/index.scss';
import './styles/themes.scss';
const App = () => _jsx(Routing, {});
export default withProviders(App);
